import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import WhyChooseUs from './components/WhyChooseUs';
import Assessment from './components/Assessment';
import Enrolment from './components/Enrolment';
import Commitment from './components/Commitment';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <main>
      <Hero />
      <About />
      <Programs />
      <WhyChooseUs />
      <Assessment />
      <Enrolment />
      <Commitment />
      <FAQ />
    </main>
  );
}
